import { UseQueryResult, useQuery } from "react-query";

import { useAxios } from "../../hooks/useAxios";

export interface IFetchWorkspaceStudentCountResponse {
  student_count: string;
}

export default function useFetchWorkspaceStudentCount(): UseQueryResult<
  IFetchWorkspaceStudentCountResponse,
  unknown
> {
  const axios = useAxios();

  const query = useQuery<IFetchWorkspaceStudentCountResponse>(
    ["workspace-student-count"],
    async (): Promise<IFetchWorkspaceStudentCountResponse> => {
      return await axios.get(`/v1/workspaces/students/count`).then((r) => {
        return r.data as IFetchWorkspaceStudentCountResponse;
      });
    }
  );

  return query;
}
